module.exports = __webpack_public_path__ + "img/23.611bf827.jpg";